export default class CartHelper {

    static populateCartIndexViewModel() {
        const eventWithDeliveryType = CartHelper.getEventWithSelectedDeliveryTypeList();
        const seasonWithDeliveryType = CartHelper.getSeasonWithSelectedDeliveryTypeList();
        const selectedProductDeliveryTypeId = CartHelper.getSelectedProductDeliveryTypeId();
        const certificateCode = CartHelper.getCertificateCode();

        const cartIndexViewModel = {
            SelectedProductDeliveryTypeId: selectedProductDeliveryTypeId,
            EventWithSelectedDeliveryTypeList: eventWithDeliveryType,
            SeasonWithDeliveryTypeList: seasonWithDeliveryType,
            certificateCode: certificateCode
        };

        return cartIndexViewModel;
    }

    static getEventWithSelectedDeliveryTypeList() {
        let eventWithSelectedDeliveryTypeList;

        if (document.querySelector('#orderEvents')) {
            const orderEvents = JSON.parse(document.querySelector('#orderEvents').value);

            const orderEventsId = orderEvents.map(function (item) { return { Event: { Id: item.id } }; });

            eventWithSelectedDeliveryTypeList = CartHelper.setEventsSelectedDeliveryTypeId(orderEventsId);
        }

        return eventWithSelectedDeliveryTypeList;
    }

    static getSeasonWithSelectedDeliveryTypeList() {
        let seasonWithSelectedDeliveryTypeList;

        if (document.querySelector('#orderSeasons')) {
            let orderSeasons = JSON.parse(document.querySelector('#orderSeasons').value);
            let orderSeasonsId = orderSeasons.map(function (item) { return { Season: { Id: item.id } }; });

            seasonWithSelectedDeliveryTypeList = CartHelper.setSeasonsSelectedDeliveryTypeId(orderSeasonsId);
        }

        return seasonWithSelectedDeliveryTypeList;
    }

    static setEventsSelectedDeliveryTypeId(orderEventsId) {
        if (typeof orderEventsId !== 'undefined' && orderEventsId.length > 0) {
            const eventDeliveryDropdowns = document.querySelectorAll('.delivery-dropdown-event');

            Array.prototype.slice.call(eventDeliveryDropdowns).forEach(function (item, index) {
                orderEventsId[index].selectedDeliveryTypeId = item.value;
            });
        }

        return orderEventsId;
    }

    static setSeasonsSelectedDeliveryTypeId(orderSeasonsId) {
        if (orderSeasonsId) {
            let seasonDeliveryDropdowns = document.querySelectorAll('.delivery-dropdown-season');
            Array.prototype.slice.call(seasonDeliveryDropdowns).forEach(function (item, index) {
                orderSeasonsId[index].selectedDeliveryTypeId = item.value;
            });
        }

        return orderSeasonsId;
    }

    static getSelectedProductDeliveryTypeId() {
        let selectedProductDeliveryTypeId;

        const productDeliveryType = document.getElementById("SelectedProductDeliveryTypeId");

        if (productDeliveryType) {
            selectedProductDeliveryTypeId = productDeliveryType[productDeliveryType.selectedIndex].value;
        }

        return selectedProductDeliveryTypeId;
    }

    static getCertificateCode() {
        let code;

        const codeInput = document.getElementById("code");

        if (codeInput) {
            code = codeInput.value;
        }

        return code;
    }

    static isAxsIdEnabled() {
        const isAxsIdEnabledElement = document.getElementById('isAxsIdEnabled');
        if (isAxsIdEnabledElement) {
            return isAxsIdEnabledElement.value.toLowerCase() === 'true';
        }

        return false;
    }

    static setCostForEventDeliveryDropdown(eventId, selectedDeliveryTypeId) {
        const orderEvents = JSON.parse((document.querySelector('#orderEvents')).value);
        const deliveryTypeElement = document.getElementById("selectedDeliveryTypeCost_" + eventId);
        const necessaryEvent = orderEvents.find(x => x.id === parseInt(eventId));
        const selectedDeliveryType = necessaryEvent.deliveryTypes.find(x => x.id === parseInt(selectedDeliveryTypeId));

        deliveryTypeElement.innerText = selectedDeliveryType.cost;
    }

    static setCostForSeasonDeliveryDropdown(seasonId, selectedDeliveryTypeId) {
        const orderSeasons = JSON.parse((document.querySelector('#orderSeasons')).value);
        const deliveryTypeElement = document.getElementById("selectedDeliveryTypeCost_" + seasonId);
        const necessarySeason = orderSeasons.find(x => x.id === parseInt(seasonId));
        const selectedDeliveryType = necessarySeason.deliveryTypes.find(x => x.id === parseInt(selectedDeliveryTypeId));

        deliveryTypeElement.innerText = selectedDeliveryType.cost;
    }

    static setCostForProductDeliveryDropdown() {
        const deliveryTypeElement = document.getElementById("selectedProductDeliveryTypeCost");
        const selectedDeliveryTypeId = document.getElementById("SelectedProductDeliveryTypeId").value;
        const productDeliveryTypes = JSON.parse(document.querySelector('#productDeliveryTypes').value);
        const selectedDeliveryType = productDeliveryTypes.find(x => x.id === parseInt(selectedDeliveryTypeId));

        deliveryTypeElement.innerText = selectedDeliveryType.cost;
    }

    static setSelectedDeliveryTypeFromEventDropdownToSession() {
        const eventWithSelectedDeliveryTypeList = CartHelper.getEventWithSelectedDeliveryTypeList();
        let eventIdsWithSelectedDeliveryTypeIds = [];
        eventWithSelectedDeliveryTypeList.forEach(function (item) {
            eventIdsWithSelectedDeliveryTypeIds.push({ "eventId": item.Event.Id, "selectedDeliveryTypeId": parseInt(item.selectedDeliveryTypeId) });
        });
        sessionStorage.setItem("selectedEventsWithDeliveryTypes", JSON.stringify(eventIdsWithSelectedDeliveryTypeIds));
    }

    static setSelectedDeliveryTypeFromSeasonDropdownToSession() {
        const seasonWithSelectedDeliveryTypeList = CartHelper.getSeasonWithSelectedDeliveryTypeList();
        let seasonIdsWithSelectedDeliveryTypeIds = [];
        seasonWithSelectedDeliveryTypeList.forEach(function (item) {
            seasonIdsWithSelectedDeliveryTypeIds.push({ "seasonId": item.Season.Id, "selectedDeliveryTypeId": parseInt(item.selectedDeliveryTypeId) });
        });
        sessionStorage.setItem("selectedSeasonsWithDeliveryTypes", JSON.stringify(seasonIdsWithSelectedDeliveryTypeIds));
    }

    static setSelectedDeliveryTypeFromProductDropdownToSession() {
        const selectedProductDeliveryTypeId = CartHelper.getSelectedProductDeliveryTypeId();
        if (selectedProductDeliveryTypeId) {
            sessionStorage.setItem("selectedProductDeliveryTypeId", selectedProductDeliveryTypeId);
        }
    }

    static setEventDeliveryDropdownsFromSession() {
        const eventDeliveryTypeElement = document.getElementById("Events_0__SelectedDeliveryTypeId");
        const selectedEventsDeliveryData = sessionStorage.getItem("selectedEventsWithDeliveryTypes");

        if (eventDeliveryTypeElement && selectedEventsDeliveryData) {
            const orderEvents = JSON.parse((document.querySelector('#orderEvents')).value);

            Array.from(orderEvents).forEach(function (event, index) {
                const eventIdWithSelectedDeliveryTypeId = JSON.parse(selectedEventsDeliveryData).find(x => x.eventId === event.id);
                const selectedDeliveryTypeElement = document.getElementById("Events_" + index + "__SelectedDeliveryTypeId");

                if (selectedDeliveryTypeElement && eventIdWithSelectedDeliveryTypeId) {
                    selectedDeliveryTypeElement.value = eventIdWithSelectedDeliveryTypeId.selectedDeliveryTypeId;
                    CartHelper.setCostForEventDeliveryDropdown(event.id, eventIdWithSelectedDeliveryTypeId.selectedDeliveryTypeId);
                }
            });
        }
    }

    static setSeasonDeliveryDropdownsFromSession() {
        const seasonDeliveryTypeElement = document.getElementById("Seasons_0__SelectedDeliveryTypeId");
        const selectedSeasonsDeliveryData = sessionStorage.getItem("selectedSeasonsWithDeliveryTypes");

        if (seasonDeliveryTypeElement && selectedSeasonsDeliveryData) {
            const orderSeasons = JSON.parse((document.querySelector('#orderSeasons')).value);

            Array.from(orderSeasons).forEach(function (season, index) {
                const seasonIdWithSelectedDeliveryTypeId = JSON.parse(selectedSeasonsDeliveryData).find(x => x.seasonId === season.id);
                const selectedDeliveryTypeElement = document.getElementById("Seasons_" + index + "__SelectedDeliveryTypeId");

                if (selectedDeliveryTypeElement && seasonIdWithSelectedDeliveryTypeId) {
                    selectedDeliveryTypeElement.value = seasonIdWithSelectedDeliveryTypeId.selectedDeliveryTypeId;
                    CartHelper.setCostForSeasonDeliveryDropdown(season.id, seasonIdWithSelectedDeliveryTypeId.selectedDeliveryTypeId);
                }
            });
        }
    }

    static setProductDeliveryDropdownFromSession() {
        const selectedProductDeliveryTypeElement = document.getElementById("SelectedProductDeliveryTypeId");
        const selectedProductDeliveryTypeId = sessionStorage.getItem("selectedProductDeliveryTypeId");

        if (selectedProductDeliveryTypeElement && selectedProductDeliveryTypeId) {
            selectedProductDeliveryTypeElement.value = selectedProductDeliveryTypeId;
            CartHelper.setCostForProductDeliveryDropdown();
        }
    }
}
